import { useNavigate } from "react-router-dom";
import { Button } from "../../components";
import React from "react";

export default function ValidatorCard({
  icon,
  title,
  tagText,
  commission,
  commissionValue,
  checkPoint,
  checkPointValue,
  apy,
  apyValue,
  performance,
  contractAddress,
  setSelectedValidator,
  validator,
  stakedIcon,
  stakedValue,
}) {
  const navigate = useNavigate();
  const handleDelegate = () => {
    const obj = {
      name: title,
      performance: performance,
      commission: commissionValue,
      contract_address: contractAddress,
    };
    setSelectedValidator(obj);
    localStorage?.setItem("selectedValidator", JSON.stringify(obj));
    navigate("/delegate");
  };

  const handleValidator = () => {
    if(commissionValue === "TBD" || tagText === "inactive"){
      return
    }
    const obj = {
      name: title,
      performance: performance,
      commission: commissionValue,
      contract_address: contractAddress,
      checkpoint_signed: checkPointValue,
      total_staked: validator?.total_staked,
      total_rewards_distributed: validator?.total_rewards_generated,
      health_status: "Healthy",
      validator_stake: "",
      delegators: validator?.delegators,
      status: validator?.status,
      ownerWallet: validator?.owner_wallet_address
    };
    setSelectedValidator(obj);
    localStorage?.setItem("selectedValidator", JSON.stringify(obj));
    setTimeout(() => {
      navigate(`/validator/${contractAddress}`);
    }, 200);
  };

  return (
    <div
      className={`${tagText!=="inactive" ? "hover:cursor-pointer" : "hover:cursor-not-allowed"} relative w-full min-h-[352px] laptop:min-h-[453px] flex flex-col justify-between rounded-[18px] border-[1.5px] border-[#FDFDFD]/[0.04] p-5 laptop:p-6 laptop:pb-5 bg-noise bg-cover bg-no-repeat bg-center bg-[#1A1A1A] overflow-hidden h-full group duration-500`}
      onClick={handleValidator}
    >
      <div className="flex justify-between w-full">
        <div className="flex items-center gap-4 laptop:gap-5">
          <div className="flex items-center justify-center p-[13px] laptop:p-[18px] w-[80px] h-[80px] laptop:w-[90px] laptop:h-[90px] rounded-3xl bg-[#010101]">
            <img src={icon} alt="" className="" />
          </div>
          <div className="flex flex-col gap-3 laptop:gap-[14px]">
            <h4 className="text-base laptop:text-[22px] font-medium leading-[18px] laptop:leading-6 text-primaryWhite">
              {title}
            </h4>
            {commissionValue !== 0 && <div
              className={`flex items-center justify-center gap-[10px] text-sm leading-none font-normal -tracking-04 px-[14px] py-3 text-green capitalize bg-green/[0.08] rounded-xl h-9 max-w-fit ${
                tagText === "inactive"
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              {tagText !== "inactive" && (
                <span className="w-[6px] h-[6px] rounded-full bg-green" />
              )}
              {tagText}
            </div>}
          </div>
        </div>
        {/* <div className="flex items-center justify-center w-8 h-8 rounded-full bg-lightGray/[0.06] p-1 *:w-full *:h-full">
                    {arrowIcon}
                </div> */}
      </div>
      <ul className="flex flex-col gap-[18px] laptop:gap-[30px]">
        <li className="flex items-center justify-between text-sm laptop:text-base font-semibold leading-5 text-primaryWhite">
          <span className="font-normal opacity-50 capitalize">
            {commission}
          </span>
          {commissionValue}
        </li>
        {/* <li className="flex items-center justify-between text-sm laptop:text-base font-semibold leading-5 text-primaryWhite">
                    <span className="font-normal opacity-50 capitalize">
                        {checkPoint}
                    </span>
                    {checkPointValue}
                </li> */}
        <li className="flex items-center justify-between text-sm laptop:text-base font-semibold leading-5 text-primaryWhite">
          <span className="font-normal opacity-50 uppercase">{apy}</span>
          {apyValue}
        </li>
      </ul>
      <div className="flex flex-col items-center gap-5">
        <Button
        id="delegate"
          className={`bg-green text-[#06080C] py-[19px] md:py-[22px] px-7 leading-none w-full ${
            commissionValue === "100%" || tagText === "inactive" ? "!opacity-50 !cursor-not-allowed" : ""
          }`}
          onClick={(e) => {
            e.stopPropagation();
            handleDelegate();
          }}
          disabled={commissionValue === "100%" || tagText === "inactive"}
        >
          {commissionValue === "TBD" && tagText === "inactive" ? "Coming Soon" :"Delegate"}
        </Button>
        <div className="flex items-center text-xsm laptop:text-sm font-medium leading-4 text-tagcolor">
          <span className="flex items-center justify-center mr-2 w-8 h-8 *:w-full *:h-full">
            {stakedIcon}
          </span>
          <span className="mr-1">{tagText === "inactive" ? 0 :stakedValue}</span> $VANRY Staked
        </div>
      </div>
    </div>
  );
}
